import { format, subDays, subYears } from "date-fns";

export function generateTimeLimitRange(timeLimit: number): [string, string] | undefined {
  if (timeLimit !== 0) {
    const toDate = new Date();
    const fromDate = subDays(subYears(toDate, timeLimit), 1);

    const timeLimitRange: [string, string] = [
      format(fromDate, "yyyy-MM-dd"),
      format(toDate, "yyyy-MM-dd"),
    ];
    return timeLimitRange;
  }
}
